import React, { useState, useEffect } from 'react';
import useStyles from './styles';
import { useTheme } from '@mui/material/styles';
import NewFormHeader from '../../../../components/NewFormHeader';
import { Strings } from '../../../../utils/strings';
import { useFormik, Form, FormikProvider } from 'formik';
import Dropdown from '../../../../components/Dropdown';
import Button from '../../../../components/Button';
import NewField from '../../../../components/NewField';
import JobFormTools from './ToolsModal';
import Textbox from '../../../../components/Textbox';
import { getErrorMessage, programTypeArray } from '../../../../utils/appUtils';
import AdditionalFormField from '../../../../components/AdditionalFormField';
import { connect } from 'react-redux';
import { fetchCategoryList } from '../../../../redux/actions/jobActions/categoryActions/categoryTypeList';
import { CircularProgress } from '@material-ui/core';
import { createJobForm } from '../../../../redux/actions/jobActions/jobActions/addJobForm';
import { AddJobFormSchema } from '../../../../utils/validationSchemas';
import { useAlert } from 'react-alert';
import { fetchJobFormById } from '../../../../redux/actions/jobActions/jobActions/getJobFormById';
import { updateJobForm } from '../../../../redux/actions/jobActions/jobActions/updateJobForm';

const NewJobForm = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [showToolBox, setShowToolBox] = useState(false);
  const [AdditionalFields, setAdditionalFields] = useState([]);
  const alert = useAlert();
  const [categoryList, setCategoryList] = useState([]);
  const onError = (err) => {
    const error = getErrorMessage(err);
    if (error) {
      alert.error(error);
    }
  };

  useEffect(() => {
    if (props.isEdit && props.data) {
      props.fetchJobFormById(props.data?._id, (err) => onError(err));
    }
    props.fetchCategoryList('form', (err) => onError(err), true);
  }, []);

  useEffect(() => {
    if (props.isEdit && props.data) {
      const data = props.jobFormData ? props.jobFormData : {};
      setFieldValue('formName', data?.formName || '');
      // setFieldValue('category', data?.formCategory || '');
      setFieldValue('formStatus', data?.formStatus || 'Active');
      setAdditionalFields(data?.formElements ? data?.formElements : []);
    }
  }, [props.jobFormData]);

  useEffect(() => {
    const data = props.categoryListData ? props.categoryListData : [];
    const newData = data.map((item) => ({
      title: item.categoryName,
      value: item._id,
    }));
    const isCategory =
      newData.filter((item) => item.value === props?.data?.formCategory?._id) ||
      [];
    if (props.data && props.isEdit && isCategory?.length === 0) {
      setCategoryList([
        {
          title: props?.data?.formCategory?.categoryName,
          value: props?.data?.formCategory?._id,
        },
        ...newData,
      ]);
    } else {
      setCategoryList(newData);
    }
  }, [props.categoryListData]);

  const formik = useFormik({
    initialValues: {
      formName: '',
      // category: '0',
      formStatus: 'Active',
    },
    validationSchema: AddJobFormSchema,

    onSubmit: (values) => {
      addNewJobForm(values);
    },
  });

  const addNewJobForm = (values) => {
    const isTitleEmpty = AdditionalFields.some((x) => !x.title);
    const uploadFileElements = AdditionalFields.filter(
      (x) => x.elementType === 'Upload File'
    );
    const isUploadFileElementsEmpty = uploadFileElements.some(
      (x) => !x.fileSize || !x.fileType || !x.allowedFiles
    );
    const filterElements = AdditionalFields.filter(
      (item) =>
        item.elementType !== 'Upload File' &&
        item.elementType !== 'Group' &&
        item.elementType !== 'Text Input'
    );
    const isElementOptionEmpty = filterElements.some((x) => {
      if (x.options?.length > 0) {
        return x.options.some((y) => !y.option);
      } else {
        return true;
      }
    });

    const filterGroupElements = AdditionalFields.filter(
      (item) => item.elementType === 'Group'
    );

    const isElementGroupTitleEmpty = filterGroupElements.some((x) =>
      x.groupElements?.some((item) => !item.title)
    );

    const isElementGroupOptionEmpty = filterGroupElements.some((x) =>
      x.groupElements?.some((item) => {
        if (item.options?.length > 0) {
          return item.options.some((y) => !y.option);
        } else if (item.elementType === 'Text Input') {
          return false;
        } else {
          return true;
        }
      })
    );

    const isElementGroupUploadFileFieldsEmpty = filterGroupElements.some((x) =>
      x.groupElements?.some(
        (item) =>
          item.elementType === 'Upload File' &&
          (!item?.fileSize || !item?.fileType || !item?.allowedFiles)
      )
    );

    if (isTitleEmpty) alert.error(Strings.TITLE_EMPTY);
    else if (isElementOptionEmpty) alert.error(Strings.OPTION_EMPTY);
    else if (isUploadFileElementsEmpty)
      alert.error(Strings.FILL_UPLOAD_FILE_ALL_FIELDS);
    else if (isElementGroupTitleEmpty)
      alert.error(Strings.GROUPS_ELEMENTS_TITLE_EMPTY);
    else if (isElementGroupOptionEmpty)
      alert.error(Strings.GROUPS_ELEMENTS_OPTION_EMPTY);
    else if (isElementGroupUploadFileFieldsEmpty)
      alert.error(Strings.FILL_GROUP_UPLOAD_FILE_ALL_FIELDS);
    else {
      const data = {
        formName: values.formName,
        // formCategory: values.category,
        formStatus: values.formStatus,
        formElements: AdditionalFields,
      };
      if (props.isEdit && !props.isCopyForm)
        // we use same create api for copying form using isCopyForm & isEdit flag
        props.updateJobForm(props.data._id, data, props.onClose, (err) =>
          onError(err)
        );
      else props.createJobForm(data, (err) => onError(err), props.onClose);
    }
  };

  const makeid = (length) => {
    let result = '';
    const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  };

  const addNewField = async (fieldType) => {
    let newField = '';
    if (fieldType === 'Upload File') {
      newField = {
        elementType: fieldType,
        title: Strings.SELECTED_DROPDOWN,
        required: false,
        visible: true,
        fileSize: '',
        allowedFiles: null,
        fileType: '',
        // options: [
        //   { option: '', placeholder: Strings.FILE_SIZE },
        //   { option: '', placeholder: Strings.FILE_TYPE },
        //   { option: '', placeholder: Strings.NUMBER_OF_FILE },
        // ],
      };
    } else if (fieldType === 'Text Input') {
      newField = {
        elementType: fieldType,
        title: Strings.SELECTED_DROPDOWN,
        required: false,
        visible: true,
      };
    } else if (fieldType === 'Group') {
      newField = {
        elementType: fieldType,
        title: Strings.FOCUS_WEEK_PLACEHOLDER,
        required: false,
        visible: true,
      };
    } else {
      newField = {
        elementType: fieldType,
        title: Strings.SELECTED_DROPDOWN,
        required: false,
        visible: true,
        options:
          fieldType === 'Check List'
            ? [{ option: Strings.NA, color: '#ED4242' }]
            : [
                { option: Strings.ISSUES_FOUND, color: '#ED4242' },
                { option: Strings.NO_ISSUES_FOUND, color: '#ED4242' },
                { option: Strings.NA, color: '#ED4242' },
              ],
      };
    }
    let _id = await makeid(22);
    newField.id = _id;
    setAdditionalFields((prevField) => [...prevField, newField]);
    setShowToolBox(false);
  };

  const onChangeFieldSwitch = (index) => {
    let array = [...AdditionalFields];
    if (index !== -1) {
      array[index].required = !array[index].required;
      setAdditionalFields(array);
    }
  };

  const onChangeFieldSwitchVisible = (index) => {
    let array = [...AdditionalFields];
    if (index !== -1) {
      array[index].visible = !array[index].visible;
      setAdditionalFields(array);
    }
  };

  const onChangeGroupFieldSwitch = (fieldIndex, groupIndex) => {
    let array = [...AdditionalFields];
    if (fieldIndex !== -1) {
      array[groupIndex].groupElements[fieldIndex].required =
        !array[groupIndex].groupElements[fieldIndex].required;
      setAdditionalFields(array);
    }
  };

  const onChangeGroupFieldSwitchVisible = (fieldIndex, groupIndex) => {
    let array = [...AdditionalFields];
    if (fieldIndex !== -1) {
      array[groupIndex].groupElements[fieldIndex].visible =
        !array[groupIndex].groupElements[fieldIndex].visible;
      setAdditionalFields(array);
    }
  };

  const removeField = (index) => {
    let array = [...AdditionalFields];
    if (index !== -1) {
      array.splice(index, 1);
      setAdditionalFields(array);
    }
  };

  const addSubNewField = (index) => {
    let array = [...AdditionalFields];
    let newOption = { option: '', color: '#ED4242' };
    if (index >= 0) {
      array[index].options.push(newOption);
      setAdditionalFields(array);
    }
  };

  const removeSubField = (subIndex, fieldIndex) => {
    let array = [...AdditionalFields];
    if (fieldIndex !== -1) {
      array[fieldIndex].options.splice(subIndex, 1);
      setAdditionalFields(array);
    }
  };

  const addNewGroupField = async (fieldType) => {
    let array = [...AdditionalFields];
    let newField = [];
    if (fieldType.elementType === 'Upload File') {
      newField = {
        elementType: fieldType.elementType,
        title: Strings.SELECTED_DROPDOWN,
        required: false,
        visible: true,
        fileSize: '',
        allowedFiles: null,
        fileType: '',
        // options: [
        //   { option: '', placeholder: Strings.FILE_SIZE },
        //   { option: '', placeholder: Strings.FILE_TYPE },
        //   { option: '', placeholder: Strings.NUMBER_OF_FILE },
        // ],
      };
    } else if (fieldType.elementType === 'Text Input') {
      newField = {
        elementType: fieldType.elementType,
        title: Strings.SELECTED_DROPDOWN,
        required: false,
        visible: true,
      };
    } else {
      newField = {
        elementType: fieldType.elementType,
        title: Strings.SELECTED_DROPDOWN,
        required: false,
        visible: true,
        options:
          fieldType.elementType === 'Check List'
            ? [{ option: Strings.NA, color: '#ED4242' }]
            : [
                { option: Strings.ISSUES_FOUND, color: '#ED4242' },
                { option: Strings.NO_ISSUES_FOUND, color: '#ED4242' },
                { option: Strings.NA, color: '#ED4242' },
              ],
      };
    }
    let _id = await makeid(22);
    newField.id = _id;

    if (fieldType.index !== -1) {
      array[fieldType.index] = {
        ...array[fieldType.index],
        groupElements: array[fieldType.index].groupElements
          ? [...array[fieldType.index].groupElements, newField]
          : [newField],
      };
      setAdditionalFields(array);
    }
  };

  const removeGroupFields = (fieldIndex, groupIndex) => {
    let array = [...AdditionalFields];
    if (groupIndex !== -1) {
      array[groupIndex].groupElements.splice(fieldIndex, 1);
      setAdditionalFields(array);
    }
  };

  const addSubNewGroupField = (fieldIndex, groupIndex) => {
    let array = [...AdditionalFields];
    let newOption = { option: '', color: '#ED4242' };
    if (groupIndex !== -1) {
      array[groupIndex].groupElements[fieldIndex].options.push(newOption);
      setAdditionalFields(array);
    }
  };

  const removeSubNewGroupField = (fieldIndex, groupIndex, deleteIndex) => {
    let array = [...AdditionalFields];
    if (groupIndex !== -1) {
      array[groupIndex].groupElements[fieldIndex].options.splice(
        deleteIndex,
        1
      );
      setAdditionalFields(array);
    }
  };

  const fieldTextInputChange = (text, fieldIndex) => {
    let array = [...AdditionalFields];
    if (fieldIndex !== -1) {
      array[fieldIndex].title = text;
      setAdditionalFields(array);
    }
  };

  const fieldSubValueTextInputChange = (text, fieldIndex, subFieldIndex) => {
    let array = [...AdditionalFields];
    if (fieldIndex !== -1) {
      array[fieldIndex].options[subFieldIndex].option = text;
      setAdditionalFields(array);
    }
  };
  const uploadFieldValueTextInputChange = (text, fieldIndex, inputType) => {
    let array = [...AdditionalFields];
    if (fieldIndex !== -1) {
      array[fieldIndex][inputType] = text;
      setAdditionalFields(array);
    }
  };

  const groupDropDownFieldChange = (text, fieldIndex, subFieldIndex) => {
    let array = [...AdditionalFields];
    if (fieldIndex !== -1) {
      array[fieldIndex].options[subFieldIndex].color = text;
      setAdditionalFields(array);
    }
  };

  const groupFieldSubValueDropDownFieldChange = (
    text,
    groupIndex,
    fieldIndex,
    subFieldIndex
  ) => {
    let array = [...AdditionalFields];
    if (fieldIndex !== -1) {
      array[groupIndex].groupElements[fieldIndex].options[subFieldIndex].color =
        text;
      setAdditionalFields(array);
    }
  };

  const groupFieldSubTextInputChange = (text, groupIndex, fieldIndex) => {
    let array = [...AdditionalFields];
    if (fieldIndex !== -1) {
      array[groupIndex].groupElements[fieldIndex].title = text;
      setAdditionalFields(array);
    }
  };
  const groupFieldSubValueTextInputChange = (
    text,
    groupIndex,
    fieldIndex,
    subFieldIndex
  ) => {
    let array = [...AdditionalFields];
    if (fieldIndex !== -1) {
      array[groupIndex].groupElements[fieldIndex].options[
        subFieldIndex
      ].option = text;
      setAdditionalFields(array);
    }
  };
  const groupUploadFieldValueTextInputChange = (
    text,
    groupIndex,
    fieldIndex,
    inputType
  ) => {
    let array = [...AdditionalFields];
    if (fieldIndex !== -1) {
      array[groupIndex].groupElements[fieldIndex][inputType] = text;
      setAdditionalFields(array);
    }
  };

  const { errors, touched, values, handleSubmit, handleChange, setFieldValue } =
    formik;

  return (
    <>
      <div className={classes.dialog_mask} />
      <div className={classes.dialog_container}>
        <NewFormHeader
          title={
            props.isEdit && props.isCopyForm
              ? Strings.COPY_FORM
              : props.isEdit && !props.isCopyForm
              ? Strings.EDIT_JOB_FORM
              : Strings.NEW_JOB_FORM
          }
          onNewClose={props.onClose}
        />
        {props.categoryListLoading || (props.isEdit && props.jobFormLoading) ? (
          <div className={classes.flexView}>
            <CircularProgress
              style={{
                color: theme.palette.background_button,
              }}
            />
          </div>
        ) : (
          <FormikProvider value={formik}>
            <Form autoComplete='off' noValidate onSubmit={handleSubmit}>
              <div className={classes.form_details}>
                <Textbox
                  name='formName'
                  onChange={handleChange('formName')}
                  value={values.formName}
                  label={Strings.FORM_NAME}
                  error={Boolean(touched.formName && errors.formName)}
                  helperText={touched.formName && errors.formName}
                  placeholder={Strings.TYPE_HERE}
                  labelClassName={classes.form_label}
                  className={classes.form_input}
                  containerClassName={classes.form_input_container}
                />
                {/* <Dropdown
                  name='category'
                  onChange={handleChange('category')}
                  value={values.category}
                  label={Strings.CATEGORY}
                  error={Boolean(touched.category && errors.category)}
                  helperText={touched.category && errors.category}
                  title={Strings.SELECT_AN_OPTION}
                  labelClassName={classes.form_label}
                  // className={classes.form_input}
                  containerClassName={classes.form_input_container}
                  optionArray={categoryList}
                /> */}
                <Dropdown
                  name='formStatus'
                  onChange={handleChange('formStatus')}
                  value={values.formStatus}
                  label={Strings.FORM_STATUS}
                  error={Boolean(touched.formStatus && errors.formStatus)}
                  helperText={touched.formStatus && errors.formStatus}
                  // title={Strings.SELECT_AN_OPTION}
                  labelClassName={classes.form_label}
                  // className={classes.form_input}
                  containerClassName={classes.form_input_container}
                  optionArray={programTypeArray}
                />
                {AdditionalFields.length > 0 && (
                  <AdditionalFormField
                    additionalFields={AdditionalFields}
                    removeField={(index) => removeField(index)}
                    addSubNewField={(index) => addSubNewField(index)}
                    removeSubField={(index, subIndex) =>
                      removeSubField(index, subIndex)
                    }
                    addNewGroupField={(field) => addNewGroupField(field)}
                    removeGroupFields={(fieldIndex, groupIndex) =>
                      removeGroupFields(fieldIndex, groupIndex)
                    }
                    addSubNewGroupField={(fieldIndex, groupIndex) =>
                      addSubNewGroupField(fieldIndex, groupIndex)
                    }
                    removeSubNewGroupField={(
                      fieldIndex,
                      groupIndex,
                      deleteIndex
                    ) =>
                      removeSubNewGroupField(
                        fieldIndex,
                        groupIndex,
                        deleteIndex
                      )
                    }
                    fieldTextInputChange={(text, fieldIndex) =>
                      fieldTextInputChange(text, fieldIndex)
                    }
                    fieldSubValueTextInputChange={(
                      text,
                      fieldIndex,
                      subFieldIndex
                    ) =>
                      fieldSubValueTextInputChange(
                        text,
                        fieldIndex,
                        subFieldIndex
                      )
                    }
                    groupDropDownFieldChange={(
                      text,
                      fieldIndex,
                      subFieldIndex
                    ) =>
                      groupDropDownFieldChange(text, fieldIndex, subFieldIndex)
                    }
                    uploadFieldValueTextInputChange={(
                      text,
                      fieldIndex,
                      inputType
                    ) =>
                      uploadFieldValueTextInputChange(
                        text,
                        fieldIndex,
                        inputType
                      )
                    }
                    groupFieldSubTextInputChange={(
                      text,
                      groupIndex,
                      fieldIndex
                    ) =>
                      groupFieldSubTextInputChange(text, groupIndex, fieldIndex)
                    }
                    groupFieldSubValueTextInputChange={(
                      text,
                      groupIndex,
                      fieldIndex,
                      subFieldIndex
                    ) =>
                      groupFieldSubValueTextInputChange(
                        text,
                        groupIndex,
                        fieldIndex,
                        subFieldIndex
                      )
                    }
                    groupFieldSubValueDropDownFieldChange={(
                      text,
                      groupIndex,
                      fieldIndex,
                      subFieldIndex
                    ) =>
                      groupFieldSubValueDropDownFieldChange(
                        text,
                        groupIndex,
                        fieldIndex,
                        subFieldIndex
                      )
                    }
                    groupUploadFieldValueTextInputChange={(
                      text,
                      groupIndex,
                      fieldIndex,
                      inputType
                    ) =>
                      groupUploadFieldValueTextInputChange(
                        text,
                        groupIndex,
                        fieldIndex,
                        inputType
                      )
                    }
                    onChangeFieldSwitchVisible={(index) =>
                      onChangeFieldSwitchVisible(index)
                    }
                    onChangeFieldSwitch={(index) => onChangeFieldSwitch(index)}
                    onChangeGroupFieldSwitch={(fieldIndex, groupIndex) =>
                      onChangeGroupFieldSwitch(fieldIndex, groupIndex)
                    }
                    onChangeGroupFieldSwitchVisible={(fieldIndex, groupIndex) =>
                      onChangeGroupFieldSwitchVisible(fieldIndex, groupIndex)
                    }
                    setAdditionalFields={setAdditionalFields}
                  />
                )}
                <NewField
                  containerClassName={classes.form_input_container}
                  onClick={() => setShowToolBox(!showToolBox)}
                />
                {showToolBox && (
                  <JobFormTools
                    onDropDownClick={() => addNewField('Dropdown')}
                    onTextInputClick={() => addNewField('Text Input')}
                    onRadioClick={() => addNewField('Radio')}
                    // onUploadFileClick={() => addNewField('Upload File')}
                    onCheckListClick={() => addNewField('Check List')}
                    onNewGroupClick={() => addNewField('Group')}
                    isFromGroupField={false}
                  />
                )}
                <Button
                  type='submit'
                  text={
                    props.isEdit && props.isCopyForm
                      ? Strings.COPY_FORM
                      : props.isEdit && !props.isCopyForm
                      ? Strings.UPDATE_FORM
                      : Strings.ADD_NEW_FORM
                  }
                  loading={
                    props.isEdit
                      ? props.updateJobFormLoading
                      : props.addJobFormLoading
                  }
                  disabled={
                    props.isEdit
                      ? props.updateJobFormLoading
                      : props.addJobFormLoading
                  }
                  containerClassName={classes.form_input_container}
                  className={classes.add_button}
                  loaderColor={theme.palette.background_button_text}
                />
              </div>
            </Form>
          </FormikProvider>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  categoryListData: state.categoryListData.data,
  categoryListLoading: state.categoryListData.loading,

  addJobFormLoading: state.addJobFormData.loading,

  jobFormData: state.jobFormData.data,
  jobFormLoading: state.jobFormData.loading,

  updateJobFormData: state.updateJobFormData.data,
  updateJobFormLoading: state.updateJobFormData.loading,
});

export default connect(mapStateToProps, {
  fetchCategoryList,
  createJobForm,
  fetchJobFormById,
  updateJobForm,
})(NewJobForm);
